import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

// Import styles
import {
	flex,
	transitionMain,
	customMinResponsive,
	size,
	customResponsive
} from 'components/styles';

export const Container = styled.section`
	padding-top: 2rem;
	${flex({ jc: 'flex-start', fd: 'column' })}
	min-height: 100vh;
	position: relative;
	width: 100%;

	${customMinResponsive(
		size.medium,
		css`
			padding-top: 3.9rem;
			background-color: ${({ theme }) => theme.payment.background};
		`
	)};

	${customMinResponsive(
		size.large,
		css`
			padding-top: 7.9rem;
		`
	)};
`;

export const BackButton = styled.button`
	height: 3rem;
	position: absolute;
	top: 3.9rem;
	left: 6rem;
	background: transparent;
	border: none;
	cursor: pointer;

	svg {
		path {
			fill: ${({ theme }) => theme.payment.backButton};
		}

		line {
			stroke: ${({ theme }) => theme.payment.backButton};
		}

		path,
		line {
			${transitionMain}
		}
	}

	&:hover,
	&:focus {
		outline: none;

		svg {
			path {
				fill: ${({ theme }) => theme.payment.backButtonHover};
			}

			line {
				stroke: ${({ theme }) => theme.payment.backButtonHover};
			}
		}
	}

	${customResponsive(
		size.medium,
		css`
			display: none;
		`
	)}
`;

export const StyledLink = styled(Link)`
	transition: all 0.3s ease-in-out;
	text-decoration: underline;
	display: block;

	&:link,
	&:visited {
		color: ${({ theme }) => theme.modal.link};
	}

	&:hover,
	&:active {
		text-decoration: underline;
		color: ${({ theme }) => theme.modal.linkHover};
	}
`;
